import If from "@mobi/components/If"
import LogoItau from "@mobi/ds/static/icons/filled/logo-laranja.svg"

const MobileAppMenu = ({ mobileInfosApp, logoAppUrl }) => {
  return (
    <div className="mobile-menu-app">
      <p className="ds-header__mobile-menu__title">
        <If
          condition={mobileInfosApp.title}
          renderIf={mobileInfosApp.title}
          renderElse={`Para acessar a sua conta , você precisa baixar o aplicativo.`}
        />
      </p>
      <div className="ds-header__mobile-menu__app-wrapper">
        <div className="ds-header__mobile-menu__app-presentation">
          <div>
            <LogoItau
              width={64}
              height={64}
              aria-hidden={true}
              className={`ds-header__mobile-menu__app-logo lazy-image image`}
            />
            <h2 className="ds-header__mobile-menu__app-title">
              {mobileInfosApp?.name || "app Itaú"}
            </h2>
          </div>
          <p className="ds-header__mobile-menu__app-description">
            <If
              condition={mobileInfosApp.description}
              renderIf={mobileInfosApp.description}
              renderElse={
                "Um app cada vez mais completo, para você contar com diversos serviços do banco direto do celular."
              }
            />
          </p>
          <a
            href={
              mobileInfosApp?.link ||
              "https://play.google.com/store/apps/details?id=com.itaucard.activity"
            }
            theme="secondary"
            className="ds-header__mobile-menu__app-link"
            role="button"
          >
            {mobileInfosApp?.textLink || "baixar app"}
          </a>
        </div>
      </div>
      <a
        href={
          mobileInfosApp?.allAppsLink || "https://www.itau.com.br/canais-itau/"
        }
        className="ds-header__mobile-menu__link"
      >
        {mobileInfosApp?.textAllAppsLink || "ver todos os apps Itaú"}
      </a>
    </div>
  )
}

export default MobileAppMenu
